var render = function render(){var _vm=this,_c=_vm._self._c;return _c('centered',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-center pt-5"},[_c('h2',[_vm._v(_vm._s(_vm.$t('common.maintenance')))]),_vm._v(" "),_c('base-button',{attrs:{"type":"primary"},on:{"click":_vm.back}},[_vm._v(_vm._s(_vm.$t('common.retry')))])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }